/**
 * Lead-form website field: accepts bare domains (e.g. test.com), not only full URLs.
 */
export function isValidLeadWebsiteUrl(value) {
  const trimmed = String(value ?? '').trim()
  if (!trimmed) {
    return false
  }

  try {
    const candidate = /^https?:\/\//i.test(trimmed)
      ? trimmed
      : `https://${trimmed}`
    const url = new URL(candidate)
    if (url.protocol !== 'http:' && url.protocol !== 'https:') {
      return false
    }
    const host = url.hostname
    return /^[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)+$/i.test(host)
  } catch {
    return false
  }
}
